import styles from './index.module.scss';
import { AuthorizedIcon } from '../../../components';
import TrashSolidBlack from '../../../assets/icons/trash-solid-b-black.svg';
import PenToSquareSolidBlack from '../../../assets/icons/pen-to-square-solid-w-black.svg';
import FolderOpenRegular from '../../../assets/icons/folder-open-regular.svg';
import { Flex, Popconfirm, Tag, Tooltip } from 'antd';
import { IEnum } from '../../../services/type';
import { getValueFromEnum } from '../../../utils/functions';
import { ColumnType } from 'antd/es/table';
import { actionTypes } from '../../../assets/enums';
import { IFile, IOrganization, IPolicyDataSource } from '../../../types';

export const getColumns = (
  handleClickDelete: (id: number) => Promise<void>,
  handleOpenEditModal: (id: number) => Promise<void>,
  handleSetAdditionalFile: (id: number, file: IFile[]) => void,
  organizations: IOrganization[],
  policyTypes: IEnum[],
): Array<ColumnType<IPolicyDataSource> & { searchable?: boolean }> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    searchable: true,
    sorter: (a, b) => a.organization - b.organization,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Poliçe Tipi',
    dataIndex: 'policy_type',
    key: 'policy_type',
    width: 200,
    filters: policyTypes.map((item) => ({
      text: getValueFromEnum(policyTypes, item.key) || '',
      value: item.key,
    })),
    filterMode: 'tree',
    filterSearch: true,
    sorter: (a, b) => a.policy_type?.localeCompare(b.policy_type),
    render: (_: unknown, record: IPolicyDataSource) => (
      <Tag className={styles[`${record.policy_type}Tag`]}>
        {getValueFromEnum(policyTypes, record.policy_type)}
      </Tag>
    ),
  },
  {
    title: 'Poliçe No',
    dataIndex: 'policy_number',
    key: 'policy_number',
    searchable: true,
    width: 150,
    sorter: (a, b) => a.policy_number?.localeCompare(b.policy_number),
  },
  {
    title: 'Başlangıç Tarihi',
    dataIndex: 'start_date',
    key: 'start_date',
    sorter: true,
  },
  {
    title: 'Bitiş Tarihi',
    dataIndex: 'end_date',
    key: 'end_date',
    sorter: true,
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    render: (_: unknown, record: IPolicyDataSource) => (
      <Flex justify="flex-end" gap={14}>
        <Popconfirm
          title={
            <div className={styles.popconfirmTitle}>
              Silme işlemini onaylıyor musunuz?
            </div>
          }
          overlayInnerStyle={{
            width: 150,
            borderColor: '#D6222A',
            borderWidth: 1,
            borderStyle: 'solid',
          }}
          okText="Onayla"
          cancelText="İptal"
          icon={null}
          color="#FAFAFA"
          okButtonProps={{ danger: true, style: { width: '45%' } }}
          cancelButtonProps={{ danger: true, style: { width: '45%' } }}
          onConfirm={() => handleClickDelete(record.id)}
        >
          <AuthorizedIcon
            action="delete"
            model="transportationpolicy"
            popoverText={actionTypes.DELETE}
            source={TrashSolidBlack}
          />
        </Popconfirm>
        <AuthorizedIcon
          action="change"
          model="transportationpolicy"
          popoverText={actionTypes.CHANGE}
          source={PenToSquareSolidBlack}
          onClick={() => handleOpenEditModal(record.id)}
        />
        <AuthorizedIcon
          action="view"
          model="transportationpolicyadditionalfile"
          popoverText={actionTypes.ADDITIONAL_FILE}
          source={FolderOpenRegular}
          onClick={() =>
            handleSetAdditionalFile(record.id, record.additional_files)
          }
        />
      </Flex>
    ),
  },
];
